import React, { useState } from 'react';
import './Seasons.css';
import Spring from './images/Spring.jpg'; // Example images
import Summer from './images/Summer1.jpg';
import Winter from './images/Winter.jpg'; // Example images
import Autum from './images/Autum.jpg';

const projects = [
  {
    title: "Spring Season",
    description: "Warmer temperatures and longer days.Blooming flowers and budding trees.Often associated with renewal and growth.",
    steps: [
        "Agriculture: Planting season for many crops, providing a new cycle of growth.",

       " Wildlife: Animals come out of hibernation, and many species breed and give birth.",
        
        "Cultural: Celebrations like Easter and Holi mark the renewal and rebirth themes of spring."
    ],
    image: Spring
  },
  {
    title: "Summer Season",
    description: "The hottest season with long, sunny days. School vacations and various outdoor activities.Abundant vegetation and peak of growing season for many crops..",
    steps: [
        "Recreation: Ideal time for vacations, swimming, and other outdoor activities.",

       " Agriculture: Harvesting of various fruits, vegetables, and grains.",
        
        "Energy: Solar energy production is at its peak due to long daylight hours."
    ],
    image: Summer
  },
  {
    title: "Winter Season",
    description: "Coldest season with short days and long nights.Snowfall and freezing temperatures in many regions.Dormant vegetation and a period of rest for many plants.",
    steps: [
        "Rest and Reflection: Time for rest and reflection, aligning with many cultural traditions and holidays like Christmas and Hanukkah.",

       " Water Supply: Snow and ice melt in spring to provide crucial water resources.",
        
        "Wildlife: Some animals hibernate or adapt to the colder conditions."
    ],
    image: Winter
  },
  {
    title: "Autumn/Fall Season",
    description: "Cooler temperatures and shorter days.Leaves change color and fall from trees.Transition from summer to winter.",
    steps: [
        "Harvest: Main harvesting season for many crops; Thanksgiving and harvest festivals are celebrated.",

       " Wildlife: Animals prepare for winter by storing food or migrating.",
        
        "Cultural: Celebrations like Halloween and Diwali reflect themes of change and preparation for the colder months."
    ],
    image: Autum
  },
  //Monsoon: Characterized by heavy rainfall, vital for water resources and agriculture.
  //Dry Season: A period of little to no rainfall, critical for planning water usage and crop planting.
];

const Seasons = () => {
  const [currentProject, setCurrentProject] = useState(null);

  const handleProjectClick = (project) => {
    setCurrentProject(project);
  };

  return (
    <div className="AppProjects">
      <h1>SEASONS</h1>
      <div className="project-buttons">
        {projects.map((project, index) => (
          <button key={index} onClick={() => handleProjectClick(project)}>
            {project.title}
          </button>
        ))}
      </div>
      {currentProject && (
        <div className="project-details">
          <h2>{currentProject.title}</h2>
          <img src={currentProject.image} alt={currentProject.title} />
          <p>{currentProject.description}</p>
          <h3>Importance & others:</h3>
          <ol>
            {currentProject.steps.map((step, index) => (
              <li key={index}>{step}</li>
            ))}
          </ol>
        </div>
      )}
    </div>
  );
};

export default Seasons;